import {
  Component,
  Input,
  ViewChild,
  ElementRef,
  AfterViewInit,
  OnInit,
} from '@angular/core';
import { Store } from '@ngrx/store';
import { appendComment, setCommentDraft } from '../store/editor.actions';
import { ExtendedComment } from '../../elements/resource/types/shape.type';
import { CanvasService } from '../../services/canvas/canvas.service';

export const PADDING = 4;

@Component({
  selector: 'nw-comment-thread',
  templateUrl: './comment-thread.component.html',
  styleUrls: ['./comment-thread.component.scss'],
})
export class CommentThreadComponent implements OnInit, AfterViewInit {
  @ViewChild('currentComment') currentComment: ElementRef;

  constructor(
    private store: Store,
    private readonly cs: CanvasService,
  ) {}

  newComment: string;

  ngOnInit(): void {
    this.cs.generalEventSubscribe('globalClick', () => {
      // console.log('comment-thread - globalClick', this.draft);
      this.store.dispatch(
        setCommentDraft({ commentIRI: this.config.IRI, text: this.draft }),
      );
    });
  }

  autoResizeTextarea() {
    const textarea = this.currentComment?.nativeElement;
    if (textarea) {
      // console.log('--- auto-resize-textarea ---', textarea.value); //
      textarea.style.height = '16px';
      // Only grow if content is multiline
      const lines = textarea.value.split('\n').length;
      // console.log('textArea.scrollHeight', textarea.scrollHeight)
      if (lines > 1 || textarea.scrollHeight > 16 + 2 * PADDING) {
        // console.log('text-area.scrollHeight', textarea.scrollHeight)
        textarea.style.height = textarea.scrollHeight - 2 * PADDING + 'px';
      }
    }
  }

  _config: {
    IRI: string;
    position: { x: number; y: number };
    comments: ExtendedComment[];
    draft?: string;
  };

  @Input()
  set config(val: {
    IRI: string;
    position: { x: number; y: number };
    comments: ExtendedComment[];
    draft?: string;
  }) {
    this._config = val;
    this.draft = val.draft || '';
    setTimeout(() => this.focusTextArea(), 1);
  }

  get config() {
    return this._config;
  }

  get comments() {
    return this.config.comments;
  }
  get x() {
    return this.config.position.x + 48;
  }
  get y() {
    return this.config.position.y - 16;
  }
  ngAfterViewInit() {}
  focusTextArea() {
    const textarea = this.currentComment?.nativeElement;
    if (textarea) {
      textarea.style.height = '16px';
      textarea.value = this.draft;
      textarea.focus();
    }
  }

  draft: string;

  submitComment() {
    this.newComment = '';
    const textarea = this.currentComment?.nativeElement;
    const text = textarea?.value?.trim();
    if (text) {
      this.store.dispatch(appendComment({ text, time: new Date().getTime() }));
      textarea.value = '';
      textarea.style.height = '16px';
    }
  }

  handleKeydown(event: KeyboardEvent) {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      this.submitComment();
    }
  }

  handleIconClick() {
    this.submitComment();
  }
}
